import { Formik } from 'formik';

import type { ScheduleMessage } from '../../../../types/ScheduleMessage';
import type { ItemModel } from '../../../common/models/ItemModel';
import type { PriceCompareFormValues } from '../types/PriceCompareFormValues';
import { createPriceCompareItem } from '../utils/createPriceCompareItem';
import { createPriceComparePort } from '../utils/createPriceComparePort';

import { OverlayPriceCompareForm } from './OverlayPriceCompareForm';

interface OverlayPriceInfoSectionProps {
    items: ItemModel[];
    portIds: string[];
    customerId: string;
    vesselId: string;
    defaultContractId?: string;
    schedules: ScheduleMessage[];
    deliveryDate?: string;
}

export const OverlayPriceInfoSection = ({
    items,
    portIds,
    customerId,
    vesselId,
    defaultContractId,
    schedules,
    deliveryDate,
}: OverlayPriceInfoSectionProps) => {
    const initialValues: PriceCompareFormValues = {
        items: items.map(createPriceCompareItem),
        portInformation: portIds.map(createPriceComparePort),
        customerId,
        vesselId,
    };

    return (
        <Formik<PriceCompareFormValues> initialValues={initialValues} onSubmit={() => undefined}>
            <OverlayPriceCompareForm
                defaultContractId={defaultContractId}
                schedules={schedules}
                deliveryDate={deliveryDate}
            />
        </Formik>
    );
};
